import React, { useEffect, useState } from "react";

const TimeString = props => {

    const [time_str, SetTime] = useState("");

    const MakeTime = () => {
        let hours = Math.floor(props.seconds / 60 / 60 % 60);
        let minutes = Math.floor(props.seconds / 60 % 60);
        let seconds = Math.floor(props.seconds % 60);
        let string = (hours == 0 ? "" : `${ZeroToLeft(hours)}:`) + (ZeroToLeft(minutes)) + ":" + (ZeroToLeft(seconds));
        SetTime(string);
    }

    const ZeroToLeft = (number) => {
        number = number.toString();
        if (number.length == 1) return `0${number}`;
        return number;
    }

    useEffect(() => {
        MakeTime();    
    });

    return(
        <p style={{margin: "0"}}>{time_str}</p>
    );
}

export default TimeString;